<template>
  <v-card>
    <!-- <v-card-title class="headline">
      <v-icon left color="blue" large>security</v-icon> FIRMAR DOCUMENTO
    </v-card-title> -->
    <v-alert
      outline
      color="warning"
      v-if="!demofi_ejecutandose"
      :value="true" >
      <h3 class="headline warning--text"><v-icon>warning</v-icon> Atención.-</h3>
      <p>Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador. Haga:</p>
      <p>1. Visite el siguiente enlace para su instalación y/o configuración. Presione <a target="_blank" href="https://firmadigital.bo/jacobitus4/">aquí</a>.</p>
      <p class="margin-0">2. Puede verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione <a href="" @click.prevent="verCertificado()">aquí</a>.</p>
    </v-alert>
    <v-alert
      outline
      color="info"
      icon="info"
      v-if="demofi_ejecutandose && !autenticado"
      :value="true">
      Ingrese el PIN de su Token para poder firmar el documento.
    </v-alert>
    <v-alert
      outline
      v-if="certificados.length"
      color="success"
      icon="check"
      :value="true">
      Token iniciado correctamente
    </v-alert>
    <v-card-text>
      <v-container grid-list-md>
        <v-form
          @submit.prevent="autenticar"
          ref="form"
          lazy-validation>
          <!-- <v-layout wrap v-if="!autenticado"> -->
          <v-layout wrap v-if="!autenticado && !$store.state.pin">
            <v-flex xs7>
              <v-text-field
                label="Pin"
                type="password"
                prepend-icon="verified_user"
                :rules="$validate(['required'])"
                v-model="pin"
                :disabled="!token_conectado || autenticado"
                ></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-btn
                type="submit"
                color="primary"
                :disabled="!token_conectado || autenticado"> Autenticar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <div v-if="certificados.length">
          <h4><v-icon>person</v-icon> Información del Token</h4>
          <div class="demofi-certificado" v-if="segmento">
            <p><strong>Nombre:</strong> {{ firmador.nombreComunSubject }}</p>
            <p><strong>Organización:</strong> {{ firmador.organizacionSubject }}</p>
            <p><em>Token válido desde el <strong>{{ firmador.inicioValidez }}</strong> hasta el <strong>{{ firmador.finValidez }}</strong></em></p>
          </div>
          <v-select
            label="Certificado"
            :rules="$validate(['required'])"
            v-model="firmadorSeleccionado"
            prepend-icon="person"
            class="p-b-0"
            :disabled="!autenticado"
            item-text="nombreComunSubject"
            item-value="numeroSerie"
            :items="certificados"
            ></v-select>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions v-show="false">
      <v-layout row>
        <v-flex xs12 center>
          <!-- <v-btn
            @click.native="$store.commit('closeModal',4)">
            <v-icon left>cancel</v-icon>Cancelar
          </v-btn> -->
          <template v-if="existeCertificados">
            <v-btn
              v-if="certificados.length"
              id="btn-demofi-firm"
              color="success"
              @click="firmar"
              :disabled="!autenticado || firmando">
            <v-icon left>security</v-icon>Firmar</v-btn>
          </template>
        </v-flex>
      </v-layout>
    </v-card-actions>
    <v-card-actions v-show="certificados.length === 0 && autenticado">
      <v-layout row>
        <v-flex xs12 center>
          <v-icon left color="warning">warning</v-icon>No se encontraron certificados válidos en su token
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
import validate from '@/common/mixins/validate';
import moment from 'moment';
import axios from 'axios';

export default {
  mixins: [ validate ],
  created () {
    this.iniciado = false;
    this.solicitudes = [{
      url_source_pdf: `${this.$apiUrl}eapostilla/apostilla/${this.solicitud.id_archivo}/${this.solicitud.id}`,
      nombre_archivo: 'documento.pdf',
      codigo_archivo: 'asada-adas-a-fwq-rfqw-rqasa-wrqw',
      id: this.solicitud.id,
      id_archivo: this.solicitud.id_archivo,
      tramite_solicitante_email: this.solicitud.tramite_solicitante_email
    }];
    this.url = `https://localhost:3200`;
    this.urlTokens = `${this.url}/tokens`;
    this.urlStart = `${this.url}/start`;
    this.urlCerts = `${this.url}/certs`;
    this.urlSign = `${this.url}/sign`;
    this.urlFinish = `${this.url}/finish`;
    this.urlStatus = `${this.url}/estadoToken`;
    this.urlKill = `${this.url}/matarProceso`;
    this.verificarTokenConectado();
  },
  data () {
    return {
      url: ``,
      noDemofi: `Demofi no se está ejecutando en su equipo. Verifique que el programa se esté ejecutando en su máquina.`,
      pin: undefined,
      tokens: [],
      certificados: [],
      firmados: 0,
      iniciado: false,
      iniciando: false,
      firmador: null,
      solicitudes: [],
      autenticado: false,
      autenticando: false,
      firmando: false,
      demofi_ejecutandose: false,
      token_conectado: false,
      boton_autenticar_habilitado: false,
      mostrar_progress: false,
      firmadorSeleccionado: null,
      segmento: true,
      fechaActual: null,
      existeCertificados: false
    };
  },
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    },
    onSuccess: {
      type: Function,
      default: null
    }
  },
  methods: {
    listTokens () {
      return new Promise((resolve, reject) => {
        this.$loading.show('Obteniendo información del token');
        this.$http.get(this.urlTokens)
        .then(data => {
          this.$loading.hide();
          if (data.finalizado === false) return reject(data);
          return resolve(data);
        })
        .catch(error => {
          this.$loading.hide();
          return reject({
            finalizado: false,
            mensaje: this.noDemofi,
            data: error
          });
        });
      });
    },
    kill () {
      return axios.get(this.urlKill);
    },
    statusToken () {
      return axios.get(this.urlStatus)
      .then(resp => {
        if (!resp.data || resp.data.finalizado === false || resp.data.mensaje !== 'True') throw Error();
        return true;
      })
      .catch(() => {
        return false;
      });
    },
    endSession () {
      return axios.get(this.urlFinish)
      .then(data => {
        return;
      })
      .catch(error => {
        console.log('Error al finalizar session', error);
        return;
      });
    },
    logout () {
      return this.statusToken()
      .then(estadoToken => {
        if (estadoToken && estadoToken === true) return this.endSession();
        return;
      })
      .catch(() => {
        return;
      });
    },
    login (pin) {
      return new Promise((resolve, reject) => {
        return axios.get(`${this.urlStart}?pin=${pin}`)
        .then(data => {
          if (data.data.finalizado === false) return reject(data);
          return resolve(data);
        })
        .catch(error => {
          return reject({
            finalizado: false,
            mensaje: this.noDemofi,
            data: error
          });
        });
      });
    },
    listCertificates () {
      return new Promise((resolve, reject) => {
        return axios.get(this.urlCerts)
        .then(data => {
          if (data.data.finalizado === false) return reject(data);
          return resolve(data.data);
        })
        .catch(error => {
          return reject({
            finalizado: false,
            mensaje: this.noDemofi,
            data: error
          });
        });
      });
    },
    sign (datos) {
      return new Promise((resolve, reject) => {
        return axios.post(this.urlSign, datos, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(data => resolve(data))
        .catch(error => reject({
          finalizado: false,
          mensaje: `Demofi no se esta ejecutando en su equipo.`,
          data: error
        }));
      });
    },
    logoutOLD () {
      return new Promise((resolve, reject) => {
        return this.$http.get(this.urlFinish)
        .then(data => {
          if (data.finalizado === false) return reject(data);
          this.pin = undefined;
          this.autenticado = false;
          return resolve(data);
        })
        .catch(error => {
          return reject({
            finalizado: false,
            mensaje: this.noDemofi,
            data: error
          });
        });
      });
    },
    arrayBufferToBase64 (buf) {
      buf = new Uint8Array(buf);
      var s = '';
      for (var i = 0; i < buf.byteLength; i++) s += String.fromCharCode(buf[i]);
      return btoa(s);
    },
    obtenerPdfBase64 (urlFile, firmador) {
      // console.log('Intentando obtener firma en base 64:');
      return new Promise((resolve, reject) => {
        return axios.post(urlFile, firmador, {
          responseType: 'arraybuffer',
          headers: {Authorization: `Bearer ${this.$storage.get('token')}`}
        })
        .then(response => {
          if (!response || !response.data) throw Error('No existe el arrayBuffer');
          return this.arrayBufferToBase64(response.data);
        })
        .then(base64 => resolve(base64))
        .catch(error => {
          console.log('Error al obtener archivo en base 64: ' + error);
          this.$message.error(error);
          return reject(error);
        });
      });
    },
    verCertificado () { // ------------------------------ COMENZANDO CON LAS PANTALLAS
      const w = 800;
      const h = 400;
      const y = window.outerHeight / 2 + window.screenY - (h / 2);
      const x = window.outerWidth / 2 + window.screenX - (w / 2);
      window.open(`${this.url}`, `_blank`, `toolbar=no,status=no,menubar=no,scrollbars=yes,left=${x},top=${y},width=${w},height=${h},visible=none`, '');
    },

    verificarTokenConectado () {
      if (this.iniciando === false) {
        this.iniciando = true;
        this.listTokens()
        .then(response => {
          this.iniciando = false;
          this.iniciado = true;
          this.demofi_ejecutandose = true;
          this.tokens = response.data.datos;
          this.token_conectado = response.data.datos.length > 0;
        }).catch((error) => {
          this.iniciando = false;
          this.iniciado = true;
          this.token_conectado = false;
          this.demofi_ejecutandose = false;
          console.error(error);
        });
      }
    },
    autenticar () {
      if (this.$refs.form.validate()) {
        this.mostrar_progress = true;
        this.autenticando = true;
        this.$loading.show('Autenticando token');
        return this.login(this.pin)
        .then(respLogin => {
          this.mostrar_progress = false;
          this.autenticando = false;
          this.$loading.hide();
          if (!respLogin.data || respLogin.data.finalizado === false) throw Error('Error al autenticar');
          this.boton_autenticar_habilitado = false;
          this.autenticado = true;// Obtener certificados
          this.$loading.show('Obteniendo información del token');
          return this.listCertificates();
        })
        .then(respCert => {
          this.$loading.hide();
          if (!respCert || !respCert.datos) throw Error('Error al obtener certificados');
          let certificadosValidos = [];
          for (let item in respCert.datos) {
            if (moment(respCert.datos[0].finValidez, 'DD/MM/YYYY').isAfter(moment())) {
              certificadosValidos.push(respCert.datos[item]);
            }
          }
          // console.log('hay ' + respCert.datos.length + ' certificados en el token, ' + certificadosValidos.length + ' validos');
          this.certificados = certificadosValidos;
          this.firmador = respCert.datos[0];
          this.firmadorSeleccionado = this.firmador.numeroSerie;
          this.existeCertificados = true;
          // console.log('datos adicionales,', this.firmador, this.firmadorSeleccionado);
        })
        .catch(error => {
          // console.log('Error en la autenticacion', error);
          this.$loading.hide();
          this.$message.error(error.data.mensaje || 'No se pudo acceder al token');
          this.mostrar_progress = false;
          this.autenticando = false;
          this.pin = undefined;
          this.autenticado = false;
          this.firmador = undefined;
          this.firmadorSeleccionado = null;
          this.boton_autenticar_habilitado = true;
          // console.log(error);
          return this.kill();
          // return this.logout();
        });
      }
    },
    cancelar () { // Cerrando session con el token
      return this.logout();
    },
    firmarDocumento (documento, alias, indice, total) {
      const config = {headers: { Authorization: `Bearer ${this.$storage.get('token')}` }};
      this.mostrar_progress = true;
      return new Promise((resolve, reject) => {
        documento.estado = 'DESCARGANDO';
        this.$loading.show('Obteniendo documento para firmar.' + `<br />${parseInt(indice) + 1} de ${total} documentos.`);
        return this.obtenerPdfBase64(documento.url_source_pdf)
        .then(base64Pdf => {
          console.log('--------> Revisando la obtencion del documento', base64Pdf.length);
          if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
          documento.pdf_base64 = base64Pdf;
          documento.estado = 'FIRMANDO';
          console.log('--------> Revisando antes de enviar a firmar', base64Pdf);
          return this.sign(documento, alias);
        })
        .then(respuestaFirma => {
          respuestaFirma = respuestaFirma.data;
          console.log('---------> Revisando la respuesta de la firma', respuestaFirma);
          if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
            throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
          }
          documento.estado = 'ACTUALIZANDO';
          if (!this.solicitud) throw Error('No existe la solicitud');
          const datos = {
            codigo_archivo: documento.codigo_archivo,
            pdf_base64_signed: respuestaFirma.datos.pdf_base64,
            certificado: respuestaFirma.datos.certificado,
            idTramiteDoc: documento.id,
            emailTramiteDoc: documento.tramite_solicitante_email,
            id_archivo: documento.id_archivo
          };
          let url = `${this.$apiUrl}eapostilla/update/${datos.id_archivo}`;
          console.log(' Revisando la URL de actualizacion', url);
          console.log('Datos de actualizacion', datos);
          this.$loading.show('Guardando documento firmado.' + `<br />${parseInt(indice) + 1} de ${total} documentos.`);
          return this.$http.post(url, datos, config);
        })
        .then(respuestaActualizacion => {
          console.log('--------> Revisando la respuesta del backend', respuestaActualizacion);
          documento.estado = 'ACTUALIZADO';
          return resolve(respuestaActualizacion);
        })
        .catch(error => {
          console.log('Error al firmar el documento', error);
          this.$loading.hide();
          this.mostrar_progress = false;
          documento.estado = 'ERROR_DESCARGA';
          return reject(error);
        });
      });
      // return promesa;
    },
    async firmarAsincrono (documentos, indice, alias) {
      if (indice < documentos.length) {
        try {
          let respuesta = await this.firmarDocumento(documentos[indice], alias, indice, documentos.length);
          this.correctos.push({ nombre_archivo: documentos[indice].nombre_archivo, data: respuesta });
        } catch (error) {
          this.errores.push({ nombre_archivo: documentos[indice].nombre_archivo, error });
        }
        indice++;
        await this.firmarAsincrono(documentos, indice, alias);
      } else {
        this.$store.commit('setLoading', false);
        this.$store.commit('closeModal', 2);
        this.$store.commit('closeModal', 3);
        this.$store.commit('closeModal', 4);
        this.$store.commit('closeModal', 5);
        this.$store.commit('closeModal', 7);
        this.$store.commit('setPin', undefined);
        this.$loading.hide();
        document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        this.logout();
        this.firmando = false;
        return;
      }
    },
    async firmarOLD () { // Obtener el documento en blobs
      console.log('Revisando this', this);
      let aliasSeleccionado = this.firmador.alias;
      const contador = 0;
      this.firmando = true;
      this.firmados = 0;
      this.correctos = [];
      this.errores = [];
      this.$loading.show('Firmando documento, espere por favor.');
      this.$store.commit('setLoading', true);
      const solicitudes = JSON.parse(JSON.stringify(this.solicitudes));
      await this.firmarAsincrono(solicitudes, contador, aliasSeleccionado);
      if (this.errores.length > 0) {
        this.solicitud.mensajeError = `${this.correctos.length} correctos, ${this.errores.length} con error`;
      }
      if (typeof this.onSuccess === 'function') {
        this.onSuccess(this.solicitud);
      }
    },
    firmar () {
      let aliasSeleccionado = this.firmador.alias;
      // const contador = 0;
      this.firmando = true;
      this.$loading.show('Firmando documento, espere por favor.');
      this.$store.commit('setLoading', true);
      const config = {headers: { Authorization: `Bearer ${this.$storage.get('token')}` }};
      const solicitudes = JSON.parse(JSON.stringify(this.solicitudes));
      const solicitud = solicitudes[0];
      let url = '';
      const datos = {
        codigo_archivo: solicitud.codigo_archivo,
        idTramiteDoc: solicitud.id,
        emailTramiteDoc: solicitud.tramite_solicitante_email,
        id_archivo: solicitud.id_archivo
      };
      return this.obtenerPdfBase64(solicitud.url_source_pdf, this.firmador)
      .then(base64Pdf => {
        if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
        const datosFirmar = {
          nombre_archivo: solicitud.nombre_archivo,
          pdf_base64: base64Pdf,
          alias: aliasSeleccionado
        };
        return this.sign(datosFirmar);
      })
      .then(respuestaFirma => {
        respuestaFirma = respuestaFirma.data;
        if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
          throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
        }
        if (!this.solicitud) throw Error('No existe la solicitud');
        datos.pdf_base64_signed = respuestaFirma.datos.pdf_base64;
        datos.certificado = respuestaFirma.datos.certificado;
        url = `${this.$apiUrl}eapostilla/update/${datos.id_archivo}`;
        // return this.logout();
        return;
      })
      .then(() => {
        this.$loading.show('Guardando documento firmado.');
        return this.$http.post(url, datos, config);
      })
      .then(respuestaActualizacion => {
        this.$store.commit('setLoading', false);
        this.$store.commit('closeModal', 2);
        this.$store.commit('closeModal', 3);
        this.$store.commit('closeModal', 4);
        this.$store.commit('closeModal', 5);
        this.$store.commit('closeModal', 7);
        this.$store.commit('setPin', undefined);
        this.$loading.hide();
        document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        this.logout();
        this.firmando = false;
        return;
      })
      .catch(error => {
        this.$store.commit('setLoading', false);
        this.$store.commit('closeModal', 2);
        this.$store.commit('closeModal', 3);
        this.$store.commit('closeModal', 4);
        this.$store.commit('closeModal', 5);
        this.$store.commit('closeModal', 7);
        this.$store.commit('setPin', undefined);
        this.$loading.hide();
        document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        console.log('Error al firmar el documento', error);
        this.$loading.hide();
        this.mostrar_progress = false;
      });
    }
  },
  watch: {
    'firmadorSeleccionado': function (val) {
      let seleccionado = {};
      // console.log('{+} revisando el firmador seleccionado', val);
      for (let item in this.certificados) {
        console.log('{+} es igual a ', this.certificados[item].numeroSerie);
        if (this.certificados[item].numeroSerie === val) {
          seleccionado = this.certificados[item];
        }
      }
      this.segmento = false;
      this.$nextTick(() => {
        this.segmento = true;
        this.firmador = seleccionado;
      });

      if (this.certificados.length > 0) {
        this.existeCertificados = false;
        this.$nextTick(() => {
          this.existeCertificados = true;
        });
      }
    }
  }
};
</script>

<style lang="scss">
.demofi-certificado {
  p {
    margin: 0 0 0px;

    em {
      font-size: 0.9rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Demofi.vue?729a0d36